var amdi18n={"__root":{"info_upper_text":"Please copy URL in different browser ...","info_lower_text":"... or scan QR-Code","info_mobile_text":"Please scan the QR-Code with your Mobile"},"__de":{"info_upper_text":"Bitte URL in anderen Browser kopieren ...","info_lower_text":"... oder QR-Code einlesen","info_mobile_text":"Bitte QR-Code mit Mobiltelefon einlesen"}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;


//////////////////
// WEBPACK FOOTER
// ./node_modules/amdi18n-loader!./src/main/web/js/app/view/identity/nls/IdentityTransferView_strings.js
// module id = 336
// module chunks = 1